export const resources = {
  resourcesFolderInfoText: 'Datei(en)',
  resourcesItemInfoLastUpdText: 'Zuletzt aktualisiert',
  resourcesItemInfoUploadedText: 'Hochgeladen',
  resourcesSearchInputText: 'Suchen',
  resourcesUserActionSheetOptionTitle: 'Link kopieren',
  resourcesActionCopiedAlertText: 'Link kopiert!',
  resourcesOwnersCurtainEditOptionText: 'Titel bearbeiten',
  resourcesOwnersCurtainDeleteOptionText: 'Löschen',
  resourcesOwnerCurtainHideOptionText: 'Ausblenden (Inaktiv)',
  resourcesEditPopupTitle: 'Titel bearbeiten',
  resourcesEditPopupResetButtonTitle: 'Zurücksetzen',
  resourcesEditPopupApplyButtonTitle: 'Anwenden',
  resourcesItemEditedAlertText: 'Element erfolgreich aktualisiert!',
  resourcesHidePopupTitle: 'Ausblenden',
  resourcesHidePopupText: 'Dieses Element ausblenden?',
  resourcesHidePopupCancelButtonTitle: 'Abbrechen',
  resourcesHidePopupConfirmButtonTitle: 'Bestätigen',
  resourcesDeletePopupTitle: 'Löschen',
  resourcesDeletePopupText: 'Dieses Element löschen?',
  resourcesDeletePopupCancelButtonTitle: 'Abbrechen',
  resourcesDeletePopupConfirmButtonTitle: 'Bestätigen',
  resourcesItemDeletedAlertText: 'Element erfolgreich gelöscht!',
  resourceDetailsLinkText: 'Dies ist eine externe URL und wird in einem neuen Fenster geöffnet. Öffnen?',
  resourceDetailsLinkOpenButtonTitle: 'Öffnen',
  resourceDetailsLinkOpenAgainButtonTitle: 'Erneut öffnen',
  resourceDetailsLinkCopyURLButtonTitle: 'Ziel-URL kopieren',
  resourceDetailsLinkCopiedURLAlertText: 'URL kopiert!',
  resurceDetailsLinkCurtainOptionCopyText: 'Link kopieren',
  resourceDetailsFileInfoLastUpdText: 'Zuletzt aktualisiert',
  resourceDetailsFileInfoUploadText: 'Hochgeladen',
  resourceDetailsFileSaveButtonTitle: 'Öffnen',
  resourceDetailsFileCopyButtonTitle: 'Link kopieren',
  resourcesOwnersCurtainCopyOptionText: 'Link kopieren',
  resourceDetailsFileLoadingText: 'Wird geladen...',
  resourceDetailsImageCurtainCopyOptionText: 'Link kopieren',
  resourceDetailsImageCurtainDownloadOptionText: 'Herunterladen',
  resourceFolder: 'Ordner',
  resourceAdded: 'Hinzugefügt'
}
